<template>
  <div id="app" :class="{ 'is-bare': isBareLayout }">
    <app-header v-if="!isBareLayout" />
    <main class="main-content" :class="{ 'main-bare': isBareLayout }">
      <transition name="page" mode="out-in">
        <router-view />
      </transition>
    </main>
    <app-footer v-if="!isBareLayout" />
    <auth-dialog @success="onAuthSuccess" />
    <back-to-top />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import AuthDialog from '@/components/AuthDialog.vue'
import BackToTop from '@/components/BackToTop.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter,
    AuthDialog,
    BackToTop
  },
  computed: {
    isBareLayout() {
      return !!(this.$route && this.$route.meta && this.$route.meta.bareLayout)
    }
  },
  methods: {
    onAuthSuccess() {
      window.dispatchEvent(new Event('auth-change'))
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: $bg-white;

  &.is-bare {
    background: transparent;
  }
}

.main-content {
  flex: 1;
  padding-top: calc(#{$header-height} + env(safe-area-inset-top, 0px));

  &.main-bare {
    padding-top: 0;
  }
}
</style>
